// src/auth.js
import { reactive } from 'vue';

export const authState = reactive({
  isAuthenticated: false,

  checkAuthStatus() {
    // prüfe direkt das Access-Token
    this.isAuthenticated = !!localStorage.getItem('accessToken');
  },

  login(accessToken) {
    // Token speichern & State updaten
    localStorage.setItem('accessToken', accessToken);
    this.isAuthenticated = true;
  },

  logout() {
    localStorage.removeItem('accessToken');
    this.isAuthenticated = false;
  }
});
